import { RoutingInfo } from "../../../types/RoutingInfo"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
import { RetryConfig } from "../../../utils/ErrorHandling"
import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENTITY = "PastRoutingInfo"

const loadData = async (employeeId: number): Promise<RoutingInfo[]> => {
  const pastRoutingInfo = await client.getPastRoutingInfo(employeeId)
  return pastRoutingInfo
}

export function useGetPastRoutingInfo(employeeId: number): UseQueryResult<RoutingInfo[], ResponseError> {
  return useQuery<RoutingInfo[], ResponseError>([ENTITY, employeeId], () => loadData(employeeId), {
    ...RetryConfig
  })
}
